import Menus from "../Menus";

const HelpTopicSinscrireCompetitionIndex = () => {
  const goBackLinks = [
    { label: 'Accueil', link: '/'},
    { label: 'Tous les sujets', link: '/topics'},
    { label: "Rechercher et s'inscrire", link: '/topics/rechercher'},
    { label: "S'inscrire des compétitions", link: '/topics/rechercher/sincrire-competition-index'},
  ]

  const multiMenus = [
    {title: null, filter: 'HelpTopicSinscrireCompetitionIndex'},
  ]

  return <Menus goBackLinks={goBackLinks} multiMenus={multiMenus}/>
}

export default HelpTopicSinscrireCompetitionIndex